import { render, staticRenderFns } from "./ListTasks.vue?vue&type=template&id=2ffd30b2&"
import script from "./ListTasks.vue?vue&type=script&lang=js&"
export * from "./ListTasks.vue?vue&type=script&lang=js&"
import style0 from "./ListTasks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports